import { Component } from '@angular/core';
import { environment } from './../environments/environment';
import { AppInsightsService } from './services/app-insights.service';

import '../assets/script/tableau2.min.js'; 

declare const window: any;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent {
	title = 'aldar-digital-twin-frontend-release-2';
	constructor(private appInsightsService: AppInsightsService) {
		delete window.apiUrl;
		window.apiUrl = environment.matchMakerUrl;
	}
}
